module.exports = __webpack_public_path__ + "static/media/WISENE_logo_medium.826ab74c.png";